import PropTypes from 'prop-types';
import React from 'react';
import Input from 'components/ui/input';

class InputEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: this.props.initialValue };
    }

    render() {
        const value = this.state.value;

        return (
          <Input
            onChange={() => this.setState({
                value: this.refs.input.getValue(),
            })}
            onKeyUp={this.props.onKeyUp ?  this.props.onKeyUp :(e) => {
                if (e.keyCode === 13) {
                    this.done();
                }
            }}
            onBlur={this.props.onBlur ?  this.props.onBlur : () => this.props.onValue(this.refs.input.getValue())}
            onFocus={(e) => {
                const field = e.target;
                const length = field.value.length;
                field.selectionStart = 0;
                field.selectionEnd = length;
            }}
            value={value}
            defaultValue={value}
            standalone
            ref="input"
            bsStyle={this.props.bsStyle}
            autoFocus
            {...this.props}
          />
        );
    }
}

InputEditor.propTypes = {
    initialValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onValue: PropTypes.func.isRequired,
    bsStyle: PropTypes.string.isRequired,
};

export default InputEditor;
